import React from 'react'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import './index.scss'

const InputGeogoding = ({ value, setValue, defaultValue }) => {
  return (
    <div className='inputGeocod'>
      <GooglePlacesAutocomplete
        minLengthAutocomplete={1}
        autocompletionRequest={{
          types: ['geocode'],
        }}
        selectProps={{
          value,
          onChange: setValue,
          placeholder: 'My location',
          defaultInputValue: defaultValue,
        }}
      />
    </div>
  )
}

export default InputGeogoding
